import { IPlayerRootReducerShape } from '../rootPlayerStore';

export const getIsCustomTurnstileIntegrationEnabled = (
  state: IPlayerRootReducerShape
) => {
  return state.customIntegrations.turnstile;
};
